// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import Scene from "~/scene";

/**
* @class prevodnik starych url (casti za hashem) na nova
*/
Mapy.UrlChecker = class {
	constructor() {
		/* predpis pro preklad (HASH) */
		this.CHECK_ARG_TABLE = {
			centerX: 	{name:"x",transMethod:null}, /* souradnice (_transCoords) */
			centerY:	{name:"y",transMethod:null}, /* souradnice (_transCoords) */
			x:			{name:"x",transMethod:null}, /* souradnice (_transCoords) */
			y:			{name:"y",transMethod:null}, /* souradnice (_transCoords) */
			zoom:		{name:"z",transMethod:null}, /* zoom (nativne) */
			z:			{name:"z",transMethod:null}, /* zoom (nativne) */
			typ:		{name:"l",transMethod:"_transTyp"}, /* mapove podklady I.verze */
			mm:			{name:"l",transMethod:"_transLayers"}, /* mapove podklady a vrstvy II.verze */
			st:			{name:"q",transMethod:"_transSearch"}, /*  zpracovava hledani nebo routovani ssq,ssr,sa,sss,ssp */
			ssq:		{name:"",transMethod:null}, /* resi _transSearch (query hledani) */
			ssr:		{name:"",transMethod:null}, /* resi _transSearch (?? query routovani ???) */
			sa:			{name:"",transMethod:null}, /* resi _transSearch (aktivni hledani ) */
			scrd:		{name:"",transMethod:null}, /* resi _transSearch (souradnice routovani) */
			ssp:		{name:"",transMethod:null}, /* resi _transSearch ??? */
			sss:		{name:"",transMethod:null},/* resi _transSearch ??? */
			ax:			{name:"u",transMethod:"_transUserMark"}, /* horizontalni souradnice vlastniho POI */
			ay:			{name:"",transMethod:null}, /* vertikalni souradnice vlastniho POI */
			at:			{name:"",transMethod:null}, /* title vlastniho POI */
			ad:			{name:"",transMethod:null}, /* description vlastniho POI */
			dm:			{name:"u",transMethod:"_transDistance"}  /* mereni vzdalenosti */
		};
		/* predpis pro preklad (QUERY) nepouziva se, ale at je tu videt ...*/
		this.CHECK_ARG_TABLE_QUERY = {
			centerX:	{name:"x"},
			centerY:	{name:"y"},
			q:			{name:"q"},
			query:		{name:"q"},
			mapType:	{name:"["},
			zoom:		{name:"z"},
			st:			{name:""},
			fr:			{name:"q"}
		};
		/* stare podklady (mm) */
		this.TABLE_BASIS = {
			"Z": 13,  /* zakladni */
			"T": 2,  /* turisticka */
			"F": 3,  /* foto */
			"A": 5,  /* historicka */
			"Fh": 8  /* foto 036 */
		};
		/* stare vrstvy (mm) */
		this.TABLE_LAYERS = {
			"R": "z",  /* relief */
			"P": "h",  /* hybrid (popisky) */
			"Pf": "f", /* fotky */
			"Tc": "c", /* cyklo */
			"Tt": "t", /* turist*/
			"Tr": "r"  /* doprava*/
		};

		this._isRedirected = false;
		this.parsedData = null;
		this._userMarkFlag = false;
		this._newURL = null;
		var hash = "";

		if (window.location.pathname && window.location.pathname != "/") {
			if(window.location.pathname.indexOf("redakce") == 1) {
				var sArr = window.location.search.substring(1).split("&");
				var rid = "";
				for(var i = 0; i < sArr.length; i++) {
					if(sArr[i].indexOf("reportId") != -1) {
						rid = "&" + sArr[i];
						break;
					}
				}
				hash = "#" + decodeURI(window.location.hash.split("#")[1]) + rid;
			} else {
				return this;
			}
		} else {
			hash = "#" + decodeURI(window.location.href.split("#")[1]);
		}

		var isOldHash = hash ? this._testHash(hash) : null;

		if(hash.indexOf("#!/") == 0) { return this; }

		var srch = window.location.search;
		if(srch.indexOf("?st=search") == 0) {
			this._geocachingHack(srch);
			return;
		}

		/* hack pro adresy z naseptavace na hp seznamu */
		if(window.location.pathname && window.location.pathname == "/") {
			if(window.location.search.indexOf("?query=") == 0) { /* hledani */
				var q = window.location.search.split("=");

				q.splice(0,1);
				var newUrl = "zakladni/?q=" + q.join("");
				this._newURL = {
					modern: window.location.protocol + "//" + window.location.host + "/" +newUrl,
					old: window.location.protocol + "//" + window.location.host + "#!/" + newUrl
				};
			}

			if(window.location.hash.indexOf("#d=") == 0 || window.location.hash.indexOf("#!d=") == 0 ) { /* detail */
				var h = ("#!" + decodeURI(window.location.href.split(/#!|#/)[1])).split("=")[1].split("_");
				var newUrl = "zakladni/?source=" + h[0] + "&id=" + h[1];

				this._newURL = {
					modern: window.location.protocol + "//" + window.location.host + "/" +newUrl,
					old: window.location.protocol + "//" + window.location.host + "#!/" + newUrl
				};
			}
		}


		/* konec hacku pro hledani z HP */

		if (!isOldHash && hash.indexOf("q=") == -1 && hash.indexOf("l=") == -1) { return this; }
		var urlStr = this._transcribe(hash);

		if (!urlStr) {
			urlStr = hash.indexOf("#") == 0 ? hash.substring(1) : hash;
			urlStr = urlStr.indexOf("!") == 0 ? urlStr.substring(1) : urlStr;
		}

		var urlPart = this._noHashTranscribe(urlStr);

		this._newURL = {
			modern: window.location.protocol + "//" + window.location.host + "/" + urlPart.modern,
			old: window.location.protocol + "//" + window.location.host + "/" + urlPart.old
		};
	}

	destroy() {
		//this.callChildDestructor(); todo
	}

	/* hack pro hledani z nejake predesle verze map, primarne kvuli geocaching.com */
	_geocachingHack(srch) {
		var arr = srch.split("&");
		var fr = "";
		for(var i = 0; i < arr.length; i++) {
			if(arr[i].indexOf("fr") == 0) {
				fr = arr[i].split("=")[1];
			}
		}
		if(!fr) { return; }

		var newUrl = "q=" + fr.replace(/[%][A-F][0-9A-F]/g, "");

		this._newURL = {
			modern: window.location.protocol + "//" + window.location.host + "/zakladni?" + newUrl,
			old: window.location.protocol + "//" + window.location.host + "/#!" + newUrl
		};
	}

	check() {
		if(!this._newURL) {
			return false;
		}
		if(history.replaceState) {
			!CONFIG.isScreenshoter && this._setSZNStatus(this._newURL.modern);
			history.replaceState("", "", this._newURL.modern);
			return true;
		} else {
			!CONFIG.isScreenshoter && this._setSZNStatus(this._newURL.old);
			window.location = this._newURL.old;
			return true;
		}
	}

	_setSZNStatus(url) {
		var data = "301;" + url;
		Mapy.setPhantomMeta(data);
	}

	redirected() {
		return this._isRedirected;
	}

	/* rozsekam stare url za hashem */
	_testHash(hash) {
		return hash.match(/@|&[a-z]+=+/gi);
	}

	/*  ZACATEK PREKLADU PRO MAPY 2014 */
	_noHashTranscribe(str) {
		var parsedData = this._parseForNoHash(str);
		var mapset = this._transToMapSet(parsedData);
		var params = this._parseParams(parsedData);
		var urlPart = this._buildNewUrl(mapset,params);
		return urlPart;

	}

	_parseForNoHash(str) {
		var arr = str.split("&");

		var inData = [];
		var inTable = {};

		for(var i = 0; i < arr.length; i++){
			var data = arr[i].split("=");

			if(data[0] in inTable) {
				var key = data[0];
				const index = inTable[key];
				const value = inData[index][1];
				if (value instanceof Array) {
					value.push(data[1]);
				} else {
					inData[index][1] = [];
					inData[index][1].push(value);
					inData[index][1].push(data[1]);
				}
			} else {
				inData[i] = data;
				inTable[inData[i][0]] = i;
			}

		}
		return {data:inData,keys:inTable};
	}

	/* vyberu spravny mapset */
	_transToMapSet(data) {
		var set = "zakladni";

		if (!("l" in data.keys)) {
			return set;
		}

		switch(parseInt(data.data[data.keys.l][1])) {
			case 20: /* zimni */
				set = "zimni";
				break;
			case 16: /* turisticka */
				set = "turisticka";
				break;
			case 15: /* foto chytra */
				set = "letecka" ;
				break;
			case 9: /* foto 06 */
				set = "letecka-2006" ;
				break;
			case 8: /* foto 03 */
				set = "letecka-2003" ;
				break;
			case 5: /* historicka */
				set = "historicka";
				break;
			default: /* neznam, vratim zakladni */
				set = "zakladni";
				break;
		}
		return set;
	}

	/* naberu spravne atributy */
	_parseParams(data) {
		var urlParams = {};
		var tab = "";
		if("t" in data.keys) { /* jaky byl otevreny tab */
			urlParams.tab = data.data[data.keys.t][1];
		}

		if("q" in data.keys) { /* co bylo hledano */
			urlParams.search = {};
			urlParams.search.query = data.data[data.keys.q][1];
			if(urlParams.search.query.indexOf(" nedaleko ") != -1) {
				urlParams.search.nearby = true;
			}
		}

		if(urlParams.tab == "r" || ("rc" in data.keys && "rl" in data.keys)) {

			urlParams.route = {};
			if("rc" in data.keys && "rl" in data.keys) { /* routovani */
				urlParams.route.rCoords = data.data[data.keys.rc][1];
				urlParams.route.rLabels = data.data[data.keys.rl][1];
				if("rp" in data.keys) {
					urlParams.route.rParams = data.data[data.keys.rp][1];
				}
			} else if("rp" in data.keys) {

				urlParams.route.rm = true;
				if("m" in data.keys) { /* rucni mereni */
					urlParams.route.dist = data.data[data.keys.m][1];
					urlParams.route.rParams = "";
				}
			}
		}


		if("u" in data.keys && !("d" in data.keys)) { /* uzivatelsky bod (rozepsany) nebo vice uzivatelskych bodu */
			urlParams.marks = {};
			if("umc" in data.keys && "uml" in data.keys) {
				var uml = data.data[data.keys.uml][1];
				urlParams.marks.mCoords = data.data[data.keys.umc][1];
				urlParams.marks.mLabels = uml instanceof Array ? uml : [uml];
				if("umd" in data.keys) {
					var umd = data.data[data.keys.umd][1];
					urlParams.marks.mDescription = umd instanceof Array ? umd : [umd];
				}
			}
		}

		if("d" in data.keys) { /* detail */
			var dStr = data.data[data.keys.d][1];
			var arr = dStr.split("_");
			var sep = dStr.indexOf("%2C") == -1 ? "," : "%2C";
			var source = arr[0];
			var m = arr[1].split(sep)
			var id = m.splice(0,2).join(sep);
			var t = m.join(sep);
			/* vyhybka pro uzivatelskkou znacku (jednu), ktera se zapisovala jako detail */
			if(source == "user") {
				this._parseUserMarkDetail(urlParams,id,t)
			} else {
				urlParams.detail = {};
				urlParams.detail.source = source;
				urlParams.detail.id = id;
				urlParams.detail.t = t;
			}
		}

		if("z" in data.keys) { /* zoom */
			urlParams.z = parseInt(data.data[data.keys.z][1]);
		}

		if("x" in data.keys && "y" in data.keys) {/* souradnice */
			urlParams.coords = {};
			urlParams.coords.x = parseFloat(data.data[data.keys.x][1]);
			urlParams.coords.y = parseFloat(data.data[data.keys.y][1]);
		}

		if("reportId" in data.keys) {
			urlParams.rid = data.data[data.keys.reportId][1];
		}

		return urlParams;
	}

	_parseUserMarkDetail(data,markDef,txt) {
		var sep = markDef.indexOf("%2C") == -1 ? "," : "%2C";
		var arr = markDef.split(sep);
		var coords = Scene.coordsFromWGS84(parseFloat(arr[0]),parseFloat(arr[1]))

		var text = txt.split("~");

		var title = text[0] || "";
		var desc = text[1] || "";
		data.marks = {};
		data.marks.mCoords = Scene.coordsToString([coords]);
		data.marks.mLabels = [title];
		data.marks.mDescription = [desc];
	}

	_buildNewUrl(mapset,params) {
		var path = mapset;
		var arr = []

		if(params.tab == "s") {
			if(params.detail) {
				this._buildDetailPart(params,arr);
			}

			if(params.search) {
				this._buildSearchPart(params,arr);
			}

			if(params.marks) {
				this._buildUserMarksPart(params,arr);
			}
			arr.push("l=1");
		} else if(params.tab == "r") {
			if(params.route.rm) {
				this._buildDistanceMeterPart(params,arr);
			} else {
				this._buildRoutePart(params,arr);
				//arr.push("ri=0");
			}

			arr.push("l=1");
		} else {
			if(params.search) {
				if(params.detail) {
					this._buildDetailPart(params,arr);
				}
				this._buildSearchPart(params,arr);
				arr.push("l=0");
			} else if(params.detail) {
				this._buildDetailPart(params,arr);
				arr.push("l=0");
			} else if(params.route) {
				if(params.route.rm) {
					this._buildDistanceMeterPart(params,arr);
				} else {
					this._buildRoutePart(params,arr);
				}
				arr.push("l=0");
			} else if(params.marks) {
				this._buildUserMarksPart(params,arr);
				arr.push("l=0")
			}

		}

		if(params.coords) {
			arr.push("x=" + params.coords.x);
			arr.push("y=" + params.coords.y);
		}

		if(params.z) {
			arr.push("z=" + params.z);
		}

		if(params.rid) {
			arr.push("rid=" + params.rid);
		}

		var str = "";
		var str = arr.join("&");
		var out = {
			modern: "",
			old: ""
		};
		out.modern += mapset + (mapset ? "?" : "") + str;

		out.old += "#!/" + mapset + (mapset ? "?" : "") + str;

		return out;
	}

	_buildSearchPart(params,arr) {
		if(params.search) {
			if(params.nearby) {
				arr.push("nearby");
			}
			arr.push("q=" + params.search.query);
		}
	}

	_buildDetailPart(params,arr) {
		if(params.detail) {
			arr.push("source=" + params.detail.source);
			arr.push("id=" + params.detail.id);
		}
	}

	_buildRoutePart(params,arr) {
		arr.push("planovani-trasy");
		if(params.route.rCoords && params.route.rLabels) {
			var crds = this._encodeRouteCoords(params.route.rCoords)
			arr.push("rc=" + crds);

			var labels = params.route.rLabels.split("_");
			for(var i = 0; i < labels.length; i++) {
				var txt = "rl=" + labels[i];
				arr.push(txt);

			}
			if(params.route.rParams) {
				arr.push("rp=" + params.route.rParams);
			}
		}
	}

	_encodeRouteCoords (coordsStr) {
		var arr = coordsStr.split("_");
		var coords = [];
		for(var i = 1; i < arr.length; i = i + 2) {
			// kvuli routovani z wizzarda, kde chybi vychozi souradnice
			if(arr[i-1] == "" || arr[i] == "") {
				continue;
			}
			var crd = [parseFloat(arr[i-1]),parseFloat(arr[i])];
			var c = Scene.coordsFromWGS84(crd[0],crd[1]);
			coords.push(c)
		}

		var str = Scene.coordsToString(coords);
		return str;
	}

	_buildDistanceMeterPart(params,arr) {
		arr.push("mereni-vzdalenosti");
		if(params.route.dist) {
			arr.push("rm=" + params.route.dist);
		}
	}

	_buildUserMarksPart(params,arr) {
		arr.push("vlastni-body");
		var len = params.marks.mLabels ? params.marks.mLabels.length : 0;
		var lbls = [];
		var desc = [];
		var ud = params.marks.mDescription ? params.marks.mDescription : new Array(len).join(".").split(".")

		for(var i = 0; i < len; i++) {
			lbls.push("ut=" + params.marks.mLabels[i]);
			desc.push("ud=" + ud[i]);
		}
		arr.push(desc.join("&"));
		arr.push(lbls.join("&"));
		arr.push("uc=" + params.marks.mCoords);
	}

	/*  KONEC PREKLADU PRO MAPY 2014 */

	/* vlastni preklad */
	_transcribe(hash) {
		this.parsedData = this._parse(hash);

		if (!this.parsedData.keys) {
			return this.parsedData;
		}

		var out = [];
		var crd = {};

		for (var i in this.parsedData.keys) {
			if (this.CHECK_ARG_TABLE[i] && this.CHECK_ARG_TABLE[i].name) {
				var method = this.CHECK_ARG_TABLE[i].transMethod;
				var index = this.parsedData.keys[i];
				if (method) {
					out.push(this[method](this.parsedData.data[index]));
				} else if(this.CHECK_ARG_TABLE[i].name == "x" || this.CHECK_ARG_TABLE[i].name == "y") {
					crd[this.CHECK_ARG_TABLE[i].name] = parseInt(this.parsedData.data[index][1]);
				} else {
					out.push(this.CHECK_ARG_TABLE[i].name + "=" + this.parsedData.data[index][1]);
				}
			}
		}

		/* otevreny sloupec */
		var tab = this._transTabs();
		if(tab) {
			out.push(tab);
		}

		/* souradnice */
		var coords = this._transCoords(crd);
		if(coords) {
			for(var i in coords) {
				out.push(i + "=" + coords[i]);
			}
		}

		return out.join("&");
	}

	/* rozparsovani stareho url na jednotlive casti (location.hash pouze) */
	_parse(hash) {
		var str = hash.indexOf("#") == 0 ? hash.substring(1) : hash;
		str = str.indexOf("!") == 0 ? str.substring(1) : str;
		var arr = str.split("@");
		if (arr[0] == str) {
			return str;
		}

		var inData = [];
		var inTable = {};

		for(var i = 0; i < arr.length; i++){
			inData[i] = arr[i].split("=");
			inTable[inData[i][0]] = i;
		}

		return {data:inData,keys:inTable};
	}

	/*
		prevadeni query stringu -> doplnim data naparsovana z hashe pokud tam nejsou
		(hash ma prednost pred querystringem)
	*/
	_parseUrlQueryString(query) {
		if(!query) { return null; }
		var data = query.data;
		var keys = query.keys;

		/* za hashem uz jsou souradnice (stary tvar) */
		var hashCoordOld = ("centerX" in this.parsedData.keys) && ("centerY" in this.parsedData.keys)
		/* za hashem uz jsou souradnice (novejsi tvar) */
		var hashCoordNew = ("x" in this.parsedData.keys) && ("y" in this.parsedData.keys);
		/* za hashem uz je search*/
		var hashQuery = ("ssq" in this.parsedData.keys);
		/* za hashem uz je route*/
		var hashQuery = ("srq" in this.parsedData.keys);
		/* za hashem uz je zoom */
		var hashZoom = ("zoom" in this.parsedData.keys) || ("z" in this.parsedData.keys);
		/* za hashem uz je typ podkladu */
		var hashTyp = ("typ" in this.parsedData.keys) || ("mm" in this.parsedData.keys);
		/* za hashem je jiz nejaky userMark */
		var testParams = ["ax","ay","at","ad"];
		var self = this;
		var testUserMark = (elm,index,array) => {
			if(elm in self.parsedData.keys){
				return true;
			} else {
				return false;
			}
		};

		var hashMark = testParams.every(testUserMark);

		/* budu prevadet typ mapy */
		if (!hashTyp) {
			var index = keys["mapType"];
			if(!isNaN(index)) {
				this.parsedData.data.push(["typ",data[index][1]]);
				this.parsedData.keys["typ"] = this.parsedData.data.length - 1;
			}
		}

		/* budu prevadet zoom */
		if (!hashZoom) {
			var index = keys["zoom"];
			if(!isNaN(index)) {
				this.parsedData.data.push(["zoom",data[index][1]]);
				this.parsedData.keys["zoom"] = this.parsedData.data.length - 1;
			}
		}
		/* budu prevadet query od hledani */
		if (!hashQuery) {
			if(("q" in keys) || ("query" in keys)){
				var index = isNaN(keys["q"]) ? keys["query"] : keys["q"];
				if(!isNaN(index)) {
					var str = data[index][1].replace(/\+/g," ");
					var str = decodeURIComponent(str);
					if(str.indexOf("route") != 0) {
						this.parsedData.data.push(["ssq",str]);
						this.parsedData.keys["ssq"] = this.parsedData.data.length - 1;
						this.parsedData.data.push(["st","s"]);
						this.parsedData.keys["st"] = this.parsedData.data.length - 1;
						this.parsedData.data.push(["sa","s"]);
						this.parsedData.keys["sa"] = this.parsedData.data.length - 1;
					} else if(str.indexOf("route") == 0) {
						// tady zpracuju routovaci formular
						this.parsedData.data.push(["srq",str]);
						this.parsedData.keys["srq"] = this.parsedData.data.length - 1;
						this.parsedData.data.push(["sa","r"]);
						this.parsedData.keys["sa"] = this.parsedData.data.length - 1;
						this.parsedData.data.push(["st","r"]);
						this.parsedData.keys["st"] = this.parsedData.data.length - 1;
					}
				}
			} else if(("fr" in keys) && ("st" in keys)) {
				if(data[keys["st"]][1] == "search") {
					var index = keys["fr"];
					var str = data[index][1].replace(/\+/g," ");
					var str = decodeURIComponent(str);
					this.parsedData.data.push(["ssq",str]);
					this.parsedData.keys["ssq"] = this.parsedData.data.length - 1;
					this.parsedData.data.push(["st","s"]);
					this.parsedData.keys["st"] = this.parsedData.data.length - 1;
					this.parsedData.data.push(["sa","s"]);
					this.parsedData.keys["sa"] = this.parsedData.data.length - 1;
				}
			}
		}
		/* budu prevadet souradnice */
		if (!hashCoordOld && !hashCoordNew) {
			var x_index = keys["centerX"];
			var y_index = keys["centerY"];
			if(!isNaN(x_index) && !isNaN(y_index)) {
				this.parsedData.data.push(["x",data[x_index][1]]);
				this.parsedData.keys["x"] = this.parsedData.data.length - 1;
				this.parsedData.data.push(["y",data[y_index][1]]);
				this.parsedData.keys["y"] = this.parsedData.data.length - 1;
			}
		}

		/* budu prevadet uzivatelskou znacku */
		var um = ["userMarkX","userMarkY","userMarkTitle","userMarkDescription"];
		var testUserData = (elm,index,array) => {
			if (elm in keys) {
				return true;
			} else {
				return false;
			}
		};

		var isUserMark = um.every(testUserData);

		if (!hashMark && isUserMark) {
			var index = keys["userMarkX"];
			this.parsedData.data.push(["ax",data[index][1]]);
			this.parsedData.keys["ax"] = this.parsedData.data.length - 1;

			index = keys["userMarkY"];
			this.parsedData.data.push(["ay",data[index][1]]);
			this.parsedData.keys["ay"] = this.parsedData.data.length - 1;

			index = keys["userMarkTitle"];
			this.parsedData.data.push(["at",data[index][1]]);
			this.parsedData.keys["at"] = this.parsedData.data.length - 1;

			index = keys["userMarkDescription"];
			this.parsedData.data.push(["ad",data[index][1]]);
			this.parsedData.keys["ad"] = this.parsedData.data.length - 1;
		}
	}

	/* prevod aktualne otevreneho praveho sloupce */
	_transTabs() {
		var out;

		if("sa" in this.parsedData.keys) {
			/* otvirani zalozek pro hledani nebo routovani */
			var tabIndex = this.parsedData.keys["sa"];
			var tmp = this.parsedData.data[tabIndex];
			var tab = tmp[1] == "s" ? "s" : "r";
			out = "t=" + tab;
		} else if("dm" in this.parsedData.keys) {
			/* jinak pokud je duvod otvirani mereni */
			out = "t=r&rp=m";
		} else if(this._userMarkFlag) {
			out = "t=s&u=u";
		}

		return out;
	}

	/* prevod souradnic z PP na WGS */
	_transCoords(data) {
		if(!isNaN(data.x) && !isNaN(data.y)) {
			var coords = Scene.coordsFromPP(data.x,data.y).toWGS84();
			return {
				x: coords[0],
				y: coords[1]
			};
		} else {
			return null;
		}
	}

	/* prevod nejstarsiho zapisu podkladu */
	_transTyp(data) {
		var tbl = {
			army2:5,
			ophoto:3,
			base:13
		};
		var num = (data[1] in tbl) ? tbl[data[1]] : tbl['base'];
		var out = "l=" + num;
		return out;
	}

	/* pravost dalsich mapovych vrstev */
	_transLayers(data) {
		/* rozsekam string z "mm" na pole jednotlivych typu */
		var types = this._parseLayersString(data[1]);

		var tmp = []
		/* podklad */
		var basis = "";
		/* vrstvy */
		var layers = []
		/* serializovane vrstvy po novu */
		var tmpLayers = "";

		/* projdu stare typy */
		for (var i = 0; i < types.length; i++) {
			/* vyberu podklad */
			if(!basis && types[i] in this.TABLE_BASIS) {
				basis = this.TABLE_BASIS[types[i]];
			}
			/* zapamatuji si ostatni zaple vrstvy */
			if(types[i] in this.TABLE_LAYERS) {
				layers.push(this.TABLE_LAYERS[types[i]]);
			}
		}
		/* 2-8-3-15-14-x <-- vypnuti vsech POI  */
		/* pokud podklad neni kreslena mapa zjistim zda nejsou vyple popisky */
		if (basis != this.TABLE_BASIS["Z"] && basis != this.TABLE_BASIS["T"] && types.indexOf("P") == -1 ) {
			layers.push("2-8-3-15-14-x");
		}

		/* na zakladni mape nemaji byt popisky, nikdy */
		if (basis == this.TABLE_BASIS["Z"]) {
			this._forceSwitchLayers(layers,[this.TABLE_LAYERS["P"]]);
		}

		/* na zakladni mape a historicke nejsou turist a cyklotrasy */
		if (basis == this.TABLE_BASIS["Z"] || basis == this.TABLE_BASIS["A"]) {
			this._forceSwitchLayers(layers,[this.TABLE_LAYERS["Tc"],this.TABLE_LAYERS["Tt"]]);
		}

		/* zretezim vrstvy */
		if (layers.length) {
			tmpLayers = layers.join("-");
		}

		tmp.push("l=" + basis);
		if (tmpLayers && tmpLayers.length) {
			tmp.push("c=" + tmpLayers);
		}

		return tmp.join("&");
	}

	_forceSwitchLayers(layers,arr) {
		for(var i = 0; i < arr.length; i++) {
			var index = layers.indexOf(arr[i]);
			if(index > -1) {
				layers.splice(index,1);
			}
		}
	}

	/* rozsekam stary parametr (mm) pro podklady a vrstvy na jednotlive identifikatory */
	_parseLayersString(str) {
		var types = [];
		var tmp = "";
		for(var i = 0; i < str.length; i++) {
			var nd = str.charAt(i);
			if(tmp && (nd.toUpperCase() != nd)) {
				tmp += nd;
				types.push(tmp);
				tmp = "";
			} else if(tmp && (nd.toUpperCase() == nd)) {
				types.push(tmp);
				tmp = nd;
			} else if(!tmp) {
				tmp = nd;
			} else {
				;
			}
			if(i == (str.length - 1) && tmp) {
				types.push(tmp)
			}
		}
		return types;
	}


	/* prevod hledani */
	_transSearch(data){
		var type = data[1];
		var out = [];

		var search,route;
		if(type.indexOf("s") != -1) {
			search = this._getSearch();
		}
		if(search) {
			out = out.concat(search);
		}

		if(type.indexOf("r") != -1) {
			route = this._getRoute();
		}

		if(route && route.length) {
			out = out.concat(route);
		}

		return out.join("&");
	}

	/* naparsuji si parametry pro hledani a odstrankovani */
	_getSearch() {
		var out = [];
		var query,page;

		var query = this._getParsedData("ssq");

		if(!query) {
			return null;
		}

		if(query.indexOf("poiN") != -1) {
			return null;
		}

		out.push("q=" + encodeURIComponent(query[1]));


		if("ssp" in this.parsedData.keys) {
			var coords = this._getParsedData("ssp");
			var crd = coords[1].split("_");
			var newCrd = this._parseCoords(crd);

			if(newCrd.length) {
				var newCoords = this._getNewCoordsParam(newCrd);
				out.push("qp=" + newCoords.join("_"));
			}
		}

		return out;
	}

	/* naparsuji si parametry pro routovani */
	_getRoute() {
		var out = [];

		var routeQuery = this._getParsedData("srq");

		var parsedQuery = this._parseRouteQuery(routeQuery[1]);

		if(!parsedQuery) {
			/* nepodarilo se mi naparsovat query */
			return out;
		}

		/* vyrobim novou query */
		if(parsedQuery.items.length) {
			out.push("rl=" + encodeURIComponent(parsedQuery.items.join("_")));
		} else {
			return [];
		}

		/* vyrobim nove parametry routy */
		if(parsedQuery.params) {
			out.push("rp=" + encodeURIComponent(JSON.stringify(parsedQuery.params)));
		}

		if("scrd" in this.parsedData.keys) {
			var crdsData = this._getParsedData("scrd");
		} else {
			/*
				nemam souradnice - v url nebyla nalezena trasa,
				ale muzu alespon vyplnit routovaci formular
			*/
			return out;
		}

		var crd = crdsData[1].split(",");
		crd.pop();
		var parsedCoords = this._parseCoords(crd);
		if(!parsedCoords) {
			/* nepodarilo se mi naparsovat souradnice */
			return out;
		}

		if(parsedQuery.items.length != parsedCoords.length) {
			/* pocet prujezdnich bodu nesouhlasi s poctem souradnic */
			return out
		}

		/* vyrobim nove souradnice */
		var newCoords = this._getNewCoordsParam(parsedCoords);
		out.push("rc=" + newCoords.join("_"));

		return out;
	}

	/* rozparsuji query na routu */
	_parseRouteQuery(data) {
		/* parametry vyhledane trasy */
		var rt = data.match(/[(]{1}(.*)[)]{1}/);

		var params = this._parseRouteParams(rt);

		/* jednotlive body trasy (start,cil,pres) */
		var sep = data.indexOf(":");

		if(!sep) {
			/* neni to spravne query na routu */
			return null;
		}

		var r = data.substring(sep + 1,data.length);
		var items = r.split(">");

		if(items.length < 2) {
			/* neni to spravne query na routu */
			return null;
		}

		return {
			params: params,
			items: items
		};
	}

	/* parsuji stare prarametry trasy (cyclo i auto) */
	_parseRouteParams(params) {
		if(!params || !params[1]) {
			return null;
		}

		var data = decodeURIComponent(params[1]).split(",").map(function(item){return item.trim();});

		var out = {};
		if(data[0].indexOf('bike') == 0) {
			/* cykloroutovac */
			out.criterion = data[0];
			if(data[1] && data[1] == "toll") {
				out.avoidtraffic = 1;
			}
		} else {
			/* autoroutovac */
			out.criterion = data[0];
			if(data[1] && data[1] == "tollfree") {
				out.toll = "free";
			}

		}

		return out;
	}

	/* souradnicove parametry hledani a routovani */
	_getNewCoordsParam(coords) {
		const newCoords = [];
		for(var i = 0; i < coords.length; i++ ) {
			var item = coords[i];
			newCoords.push(item.x);
			newCoords.push(item.y);
		}
		return newCoords;
	}

	/* rozparsuji query na souradnice routy */
	_parseCoords(items) {
		var out = [];
		for(var i = 0; i < items.length; i += 2 ) {
			var x = items[i];
			var y = items[i + 1];
			var coords = this._transCoords({x:x,y:y});
			if(!coords) {
				return null;
			}
			out.push(coords);
		}
		return out;
	}

	/* ziska data k zadanemu klici */
	_getParsedData(key) {
		var index =  this.parsedData.keys[key];

		if(isNaN(index)) {
			return null;
		}

		return [
				this.parsedData.data[index][0],
				decodeURIComponent(this.parsedData.data[index][1])
			];
	}

	_transUserMark() {
		/* pokud je v url i zaznam mereni vzdalenosti na userMark kasleme */
		if("dm" in this.parsedData.keys) {
			return "";
		}

		var oldParams = ["ax","ay","ad","at"];
		var mySelf = this;
		var testParams = (item) => {
			if(item in mySelf.parsedData.keys) {
				return true;
			} else {
				return false;
			}
		};
		/* otestuji, zda nechybi nejaky dulezity argument */
		if(!oldParams.every(testParams)) {
			return "";
		}
		var param = "d=user_";
		/* souradnice */
		var x = parseInt(this._getParsedData("ax")[1]);
		var y = parseInt(this._getParsedData("ay")[1]);

		var coords = Scene.coordsFromPP(x,y).toWGS84();
		param += coords[0] + "," + coords[1] + ',' + encodeURIComponent(this._getParsedData("at")[1]) + "~" + encodeURIComponent(this._getParsedData("ad")[1]) + "_1";
		this._userMarkFlag = true;
		return param;
	}

	/* prevod mereni vzdalenosti */
	_transDistance(data) {
		var items = data[1].match(/[+-]?[0-9]+/g);
		if(!items || !items.length) {
			return '';
		}

		var toNumbers = function(item) {
			return parseInt(item);
		};

		var old = items.map(toNumbers);
		var coords = this._getDistanceCoords(old);

		return "m=" + Scene.coordsToString(coords);
	}

	/* ziskani nivych souradnic ze stareho mereni vzdalenosti */
	_getDistanceCoords(items) {
		var coords = [];
		var tmpX,tmpY;
		for(var i = 0; i < items.length; i += 2) {
			if(!i) {
				tmpX = items[0];
				tmpY = items[1];
				coords.push(Scene.coordsFromPP(tmpX,tmpY));
				continue;
			}

			tmpX += items[i];
			tmpY += items[i + 1];
			coords.push(Scene.coordsFromPP(tmpX,tmpY));
		}

		return coords;
	}
};
